export const wellnessChecksKeys = {
    all: ["wellnessChecks"] as const,
    answerers: (answererId: string) =>
        [...wellnessChecksKeys.all, answererId] as const,
    detail: (id: string) => ["wellnessCheck", id] as const,
};
